export default __webpack_public_path__ + "static/media/forward.bd7d09b3.png";